module.exports = __webpack_public_path__ + "img/cloudy.309aa159.png";